var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAngry(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 28.8C23.0692 28.8 28.8 23.0693 28.8 16C28.8 8.93077 23.0692 3.20001 16 3.20001C8.93076 3.20001 3.2 8.93077 3.2 16C3.2 23.0693 8.93076 28.8 16 28.8Z",
    fill: "url(#paint0_radial_510_4591)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.752 21.1999C15.752 21.1999 18.408 21.1919 19.32 23.3039C19.376 23.4399 19.416 23.5839 19.424 23.7279C19.448 24.0239 19.24 24.3279 18.736 24.1279C17.928 23.8079 16.536 23.6479 15.752 23.6479C14.968 23.6479 13.584 23.8079 12.768 24.1279C12.264 24.3279 12.056 24.0239 12.08 23.7279C12.088 23.5839 12.128 23.4399 12.184 23.3039C13.104 21.1919 15.752 21.1999 15.752 21.1999Z",
    fill: "url(#paint1_radial_510_4591)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.824 19.2481C12.5045 19.2481 13.056 18.4135 13.056 17.3841C13.056 16.3546 12.5045 15.5201 11.824 15.5201C11.1436 15.5201 10.592 16.3546 10.592 17.3841C10.592 18.4135 11.1436 19.2481 11.824 19.2481Z",
    fill: "url(#paint2_radial_510_4591)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.336 16.7121C12.056 16.7121 12.656 17.4481 12.832 18.4481C12.976 18.1441 13.056 17.7761 13.056 17.3761C13.056 16.3441 12.504 15.5121 11.824 15.5121C11.232 15.5121 10.736 16.1361 10.616 16.9761C10.832 16.8081 11.072 16.7121 11.336 16.7121Z",
    fill: "url(#paint3_linear_510_4591)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.504 12.8399C9.40001 12.8399 8.45601 14.1119 9.68801 14.3039C10.92 14.4959 13.16 15.5599 14.112 16.2959C14.184 16.3839 14.464 16.3519 14.44 16.1359C14.44 15.3039 11.848 12.8399 10.504 12.8399Z",
    fill: "url(#paint4_linear_510_4591)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.752 21.8959C15.752 21.8959 17.912 21.8879 19.392 23.5519C19.376 23.4639 19.352 23.3839 19.312 23.3039C18.4 21.1919 15.744 21.1999 15.744 21.1999C15.744 21.1999 13.088 21.1919 12.176 23.3039C12.144 23.3839 12.12 23.4639 12.096 23.5519C13.592 21.8879 15.752 21.8959 15.752 21.8959Z",
    fill: "url(#paint5_linear_510_4591)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.176 19.2481C20.8564 19.2481 21.408 18.4135 21.408 17.3841C21.408 16.3546 20.8564 15.5201 20.176 15.5201C19.4955 15.5201 18.944 16.3546 18.944 17.3841C18.944 18.4135 19.4955 19.2481 20.176 19.2481Z",
    fill: "url(#paint6_radial_510_4591)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.664 16.7121C19.944 16.7121 19.344 17.4481 19.168 18.4481C19.024 18.1441 18.944 17.7761 18.944 17.3761C18.944 16.3441 19.496 15.5121 20.176 15.5121C20.768 15.5121 21.264 16.1361 21.384 16.9761C21.168 16.8081 20.928 16.7121 20.664 16.7121Z",
    fill: "url(#paint7_linear_510_4591)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.496 12.8399C22.6 12.8399 23.544 14.1119 22.312 14.3039C21.08 14.4959 18.84 15.5599 17.888 16.2959C17.816 16.3839 17.536 16.3519 17.56 16.1359C17.56 15.3039 20.152 12.8399 21.496 12.8399Z",
    fill: "url(#paint8_linear_510_4591)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_510_4591",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.1152 10.9044) rotate(-29.698) scale(12.9172 10.5526)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4E0D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_510_4591",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.7534 22.6973) scale(2.80266 1.49297)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_510_4591",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.447 17.4264) rotate(73.8539) scale(1.80855 1.1701)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_510_4591",
    x1: 11.8355,
    y1: 16.0851,
    x2: 11.8355,
    y2: 17.7535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_510_4591",
    x1: 11.7737,
    y1: 17.2734,
    x2: 11.7737,
    y2: 13.4063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_510_4591",
    x1: 15.7534,
    y1: 20.2906,
    x2: 15.7534,
    y2: 22.3057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_510_4591",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.5883 17.3963) rotate(106.146) scale(1.80855 1.1701)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_510_4591",
    x1: 20.1645,
    y1: 16.0851,
    x2: 20.1645,
    y2: 17.7535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_510_4591",
    x1: 20.2264,
    y1: 17.2734,
    x2: 20.2264,
    y2: 13.4063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngry);
export default __webpack_public_path__ + "static/media/angry.5f7b38c7d16aacbf7059aa846efccc15.svg";
export { ForwardRef as ReactComponent };